import { Routes, Route } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import MenuTabs from './components/Tabs';

import { AuthContextProvider } from './shared/contexts/AuthContext';
import ProtectedRoute from './shared/ProtectedRoute';

function App() {
	return (
		// Wrap the entire application with 'AuthContextProvider' to provide authentication context.
		<AuthContextProvider>
			{/* Define the routing structure using 'Routes' from 'react-router-dom'. */}
			<Routes>
				{/* 
          Define a route for the root path ("/") that renders the 'LoginPage' component.
          It is wrapped with 'ProtectedRoute' to control access for non-authenticated users.
          */}
				<Route
					path='/'
					element={
						<ProtectedRoute accessBy='non-authenticated'>
							<LoginPage />
						</ProtectedRoute>
					}
				/>
				<Route
					path='/ResetPassword'
					element={
						<ProtectedRoute accessBy='non-authenticated'>
							<ResetPasswordPage />
						</ProtectedRoute>
					}
				/>
				{/* 
          Define a route with a dynamic segment for the tab parameter ("/:tab").
          It renders the 'MenuTabs' component and is wrapped with 'ProtectedRoute'
          to restrict access to authenticated users.
          */}
				<Route
					path='/:tab'
					element={
						<ProtectedRoute accessBy='authenticated'>
							<MenuTabs />
						</ProtectedRoute>
					}
				/>
			</Routes>
		</AuthContextProvider>
	);
}

// Export the 'App' component as the main entry point of your application.
export default App;
